import { render } from "./TheFooter.vue?vue&type=template&id=1284f474&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=1284f474&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1284f474"

export default script